import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import $ from 'jquery'

const Modal = ({ module, closeButton }, ref) => {
  const bookEvent = event => {
    // fill fields, set page 1 and open form
    //console.log(training) //eslint-disable-line
    //console.log(module.id) //eslint-disable-line
    //console.log(event.date + ' | ' + event.address) //eslint-disable-line

    const $modal = $('.dhsv_vc_akademie_formular_schulung_modal')
    const form_id = 7
    const $gform = $('#gform_' + form_id)
    const $gform_footer = $gform.find('#gform_next_button_' + form_id + '_1')
    if ($gform.length) {
      const $module = $('#input_' + form_id + '_4')
      const $event = $('#input_' + form_id + '_5')

      $module.prop('disabled', false)
      $event.prop('disabled', false)

      $module.val(module.id).change()
      $event.val(event.id).change()

      $gform.css('opacity', '0')

      $gform_footer.click()

      $modal.addClass('open')
    }
  }

  const trackingEventLabel = `book ${module.title}`

  return (
    <div className={`dhsv_akademie_schulung_modal`} ref={ref}>
      {closeButton}
      <div>
        <div className="ctn">
          <p className="big red">{module.title}</p>
          <p dangerouslySetInnerHTML={{ __html: module.text }} />
        </div>
        <div className="trainer">
          <div>
            <p>Trainer</p>
            <p>{module.trainerName}</p>
          </div>
          <div>
            <img className="lazyload" data-src={module.trainerImage} />
          </div>
        </div>
        <div className="events">
          <p>Termine</p>
          {module.events && module.events.length > 0 ? (
            module.events.map((event, i) => (
              <div key={i}>
                <p>{event.date}</p>
                <p>{event.address}</p>
                <p
                  onClick={() => bookEvent(event)}
                  data-tracking-event-label={trackingEventLabel}
                >
                  buchen
                </p>
              </div>
            ))
          ) : (
            <p>
              Aufgrund der aktuellen Situation bieten wir keine Schulungen vor
              Ort an. Sobald Sie Schulungen bei uns vor Ort buchen können,
              werden wir Sie hier informieren. Wir danken Ihnen für Ihr
              Verständnis. Bleiben Sie gesund.
            </p>
          )}
        </div>
        <p className="big red price">
          {module.free ? 'Kostenlos' : 'Preis: ' + module.price}
        </p>
      </div>
    </div>
  )
}

Modal.propTypes = {
  ref: PropTypes.object,
  module: PropTypes.object,
  closeButton: PropTypes.node,
}

export default forwardRef(Modal)
